/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { Icon } from '@/components';
interface EmoErrorProps {
  reload?: any;
}

const EmoError: React.FC<EmoErrorProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { reload } = props;

    const { formatMessage } = useIntl();

    return (
      <div className={s.wrapper}>
        <Icon name="icon-statusError_solid_2" mode="symbol" size={32} className={s.icon}></Icon>
        <span className={s.text}>{formatMessage({ id: 'emoLoadedFail' })}</span>
        <span className={s.retry} onClick={reload}>
          {formatMessage({ id: 'reload' })}
        </span>
      </div>
    );
  })
);
export default EmoError;
